// auth: the words of these screens in both languages. Each table is the
// one its component defined; moved here verbatim so a domain reads as one
// vocabulary and a translation is corrected in one place.

// pages/Login.jsx
export const loginL = {
  en: {
    title: "Sign in or create an account",
    sub: "Sign in to find your bookings and manage your account details.",
    google: "Continue with Google", or: "OR",
    email: "Email address", password: "Password", submit: "Sign in",
    newHere: "New to Toukky?", create: "Create an account", forgot: "Forgot your password?",
    secured: "Keep your password private.",
    welcome: "Welcome back!", claimed: "Booking added to your account",
    googleFailed: "Google sign-in failed", error: "We could not sign you in. Please try again.",
    wrongCredentials: "Incorrect e-mail or password. Check them and try again.",
    restart: "Verification could not be completed. Sign in again to get a new verification request.",
  },
  fr: {
    title: "Connectez-vous ou créez un compte",
    sub: "Connectez-vous pour retrouver vos réservations et gérer les informations de votre compte.",
    google: "Continuer avec Google", or: "OU",
    email: "Adresse e-mail", password: "Mot de passe", submit: "Se connecter",
    newHere: "Nouveau sur Toukky ?", create: "Créer un compte", forgot: "Mot de passe oublié ?",
    secured: "Ne communiquez jamais votre mot de passe.",
    welcome: "Bon retour !", claimed: "Réservation ajoutée à votre compte",
    googleFailed: "Échec de la connexion Google", error: "Impossible de vous connecter. Veuillez réessayer.",
    wrongCredentials: "E-mail ou mot de passe incorrect. Vérifiez-les et réessayez.",
    restart: "La vérification n’a pas abouti. Reconnectez-vous pour obtenir une nouvelle demande de vérification.",
  },
  es: {
    title: "Inicia sesión o crea una cuenta",
    sub: "Inicie sesión para consultar sus reservas y gestionar los datos de su cuenta.",
    google: "Continuar con Google", or: "O",
    email: "Correo electrónico", password: "Contraseña", submit: "Iniciar sesión",
    newHere: "¿Nuevo en Toukky?", create: "Crear una cuenta", forgot: "¿Olvidaste tu contraseña?",
    secured: "No comparta su contraseña.",
    welcome: "¡Qué bueno verte de nuevo!", claimed: "Reserva añadida a tu cuenta",
    googleFailed: "Error al iniciar sesión con Google", error: "No se pudo iniciar sesión. Inténtelo de nuevo.",
    wrongCredentials: "Correo electrónico o contraseña incorrectos. Revísalos e inténtalo de nuevo.",
    restart: "No se pudo completar la verificación. Inicia sesión de nuevo para recibir una nueva solicitud de verificación.",
  },
  pt: {
    title: "Inicie sessão ou crie uma conta",
    sub: "Inicie sessão para consultar as suas reservas e gerir os dados da sua conta.",
    google: "Continuar com o Google", or: "OU",
    email: "Endereço de e-mail", password: "Palavra-passe", submit: "Iniciar sessão",
    newHere: "Novo na Toukky?", create: "Criar uma conta", forgot: "Esqueceu a palavra-passe?",
    secured: "Não partilhe a sua palavra-passe.",
    welcome: "Bem-vindo de volta!", claimed: "Reserva adicionada à sua conta",
    googleFailed: "Falha ao iniciar sessão com o Google", error: "Não foi possível iniciar sessão. Tente novamente.",
    wrongCredentials: "E-mail ou palavra-passe incorretos. Verifique-os e tente novamente.",
    restart: "Não foi possível concluir a verificação. Inicie sessão novamente para receber um novo pedido de verificação.",
  },
  ar: {
    title: "سجّل الدخول أو أنشئ حسابًا",
    sub: "سجّل الدخول للاطلاع على حجوزاتك وإدارة بيانات حسابك.",
    google: "المتابعة عبر Google", or: "أو",
    email: "البريد الإلكتروني", password: "كلمة المرور", submit: "تسجيل الدخول",
    newHere: "جديد على Toukky؟", create: "إنشاء حساب", forgot: "هل نسيت كلمة المرور؟",
    secured: "لا تشارك كلمة المرور الخاصة بك.",
    welcome: "أهلًا بعودتك!", claimed: "تمت إضافة الحجز إلى حسابك",
    googleFailed: "فشل تسجيل الدخول عبر Google", error: "تعذر تسجيل الدخول. يرجى المحاولة مجددًا.",
    wrongCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة. تحقق منهما وحاول مرة أخرى.",
    restart: "تعذّر إكمال التحقق. سجّل الدخول مجددًا للحصول على طلب تحقق جديد.",
  },
  zh: {
    title: "登录或创建账户",
    sub: "登录后可查看预订并管理账户信息。",
    google: "使用 Google 继续", or: "或",
    email: "电子邮箱", password: "密码", submit: "登录",
    newHere: "初次使用 Toukky？", create: "创建账户", forgot: "忘记密码？",
    secured: "请勿向他人透露密码。",
    welcome: "欢迎回来！", claimed: "预订已添加到您的账户",
    googleFailed: "Google 登录失败", error: "无法登录，请重试。",
    wrongCredentials: "电子邮件或密码不正确。请检查后重试。",
    restart: "验证未能完成。请重新登录以获取新的验证请求。",
  },
};

// pages/Signup.jsx
export const signupL = {
  en: {
    title: "Create your account",
    sub: "Create a Toukky account to keep your bookings and contact details in one place.",
    google: "Continue with Google", or: "OR",
    name: "Full name", email: "Email address", password: "Password",
    passwordHint: (n) => `At least ${n} characters.`,
    submit: "Create account",
    haveAccount: "Already have an account?", signIn: "Sign in",
    termsBefore: "By creating an account, you agree to Toukky's", termsLink: "Terms", termsAnd: "and", privacyLink: "Privacy Policy", termsAfter: ".",
    created: "Account created!", claimed: "Booking added to your account", error: "Your account could not be created. Check your details and try again.",
  },
  fr: {
    title: "Créez votre compte",
    sub: "Créez votre compte Toukky pour retrouver vos réservations et vos coordonnées au même endroit.",
    google: "Continuer avec Google", or: "OU",
    name: "Nom complet", email: "Adresse e-mail", password: "Mot de passe",
    passwordHint: (n) => `${n} caractères minimum.`,
    submit: "Créer mon compte",
    haveAccount: "Vous avez déjà un compte ?", signIn: "Connectez-vous",
    termsBefore: "En créant un compte, vous acceptez les", termsLink: "conditions générales", termsAnd: "et la", privacyLink: "politique de confidentialité", termsAfter: " de Toukky.",
    created: "Compte créé !", claimed: "Réservation ajoutée à votre compte", error: "Votre compte n’a pas pu être créé. Vérifiez les informations saisies et réessayez.",
  },
  es: {
    title: "Crea tu cuenta",
    sub: "Cree su cuenta Toukky para reunir sus reservas y datos de contacto.",
    google: "Continuar con Google", or: "O",
    name: "Nombre completo", email: "Correo electrónico", password: "Contraseña",
    passwordHint: (n) => `Mínimo ${n} caracteres.`,
    submit: "Crear cuenta",
    haveAccount: "¿Ya tienes una cuenta?", signIn: "Inicia sesión",
    termsBefore: "Al crear una cuenta, aceptas los", termsLink: "Términos", termsAnd: "y la", privacyLink: "Política de privacidad", termsAfter: " de Toukky.",
    created: "¡Cuenta creada!", claimed: "Reserva añadida a tu cuenta", error: "No se pudo crear su cuenta. Revise los datos e inténtelo de nuevo.",
  },
  pt: {
    title: "Crie a sua conta",
    sub: "Crie a sua conta Toukky para reunir as reservas e os dados de contacto.",
    google: "Continuar com o Google", or: "OU",
    name: "Nome completo", email: "Endereço de e-mail", password: "Palavra-passe",
    passwordHint: (n) => `Mínimo de ${n} caracteres.`,
    submit: "Criar conta",
    haveAccount: "Já tem uma conta?", signIn: "Iniciar sessão",
    termsBefore: "Ao criar uma conta, aceita os", termsLink: "Termos", termsAnd: "e a", privacyLink: "Política de Privacidade", termsAfter: " da Toukky.",
    created: "Conta criada!", claimed: "Reserva adicionada à sua conta", error: "Não foi possível criar a conta. Verifique os dados e tente novamente.",
  },
  ar: {
    title: "أنشئ حسابك",
    sub: "أنشئ حساب Toukky للاحتفاظ بحجوزاتك وبيانات الاتصال في مكان واحد.",
    google: "المتابعة عبر Google", or: "أو",
    name: "الاسم الكامل", email: "البريد الإلكتروني", password: "كلمة المرور",
    passwordHint: (n) => `${n} أحرف على الأقل.`,
    submit: "إنشاء حساب",
    haveAccount: "هل لديك حساب بالفعل؟", signIn: "تسجيل الدخول",
    termsBefore: "بإنشاء حساب، فإنك توافق على", termsLink: "الشروط", termsAnd: "و", privacyLink: "سياسة الخصوصية", termsAfter: " الخاصة بـ Toukky.",
    created: "تم إنشاء الحساب!", claimed: "تمت إضافة الحجز إلى حسابك", error: "تعذر إنشاء حسابك. تحقق من البيانات وحاول مجددًا.",
  },
  zh: {
    title: "创建您的账户",
    sub: "创建 Toukky 账户，集中查看预订和联系信息。",
    google: "使用 Google 继续", or: "或",
    name: "全名", email: "电子邮箱", password: "密码",
    passwordHint: (n) => `至少 ${n} 个字符。`,
    submit: "创建账户",
    haveAccount: "已有账户？", signIn: "登录",
    termsBefore: "创建账户即表示您同意 Toukky 的", termsLink: "条款", termsAnd: "和", privacyLink: "隐私政策", termsAfter: "。",
    created: "账户已创建！", claimed: "预订已添加到您的账户", error: "无法创建账户，请核对信息后重试。",
  },
};

// pages/AuthCallback.jsx
export const authCallbackL = {
  en: { ok: "Signed in with Google", failed: "Google sign-in failed", busy: "Signing you in…" },
  fr: { ok: "Connecté avec Google", failed: "Échec de la connexion Google", busy: "Connexion en cours…" },
  es: { ok: "Sesión iniciada con Google", failed: "Error al iniciar sesión con Google", busy: "Iniciando sesión…" },
  pt: { ok: "Sessão iniciada com o Google", failed: "Falha ao iniciar sessão com o Google", busy: "A iniciar sessão…" },
  ar: { ok: "تم تسجيل الدخول عبر Google", failed: "فشل تسجيل الدخول عبر Google", busy: "جارٍ تسجيل دخولك…" },
  zh: { ok: "已通过 Google 登录", failed: "Google 登录失败", busy: "正在登录…" },
};

// pages/admin/AdminLogin.jsx
export const adminLoginL = {
  en: {
    admin: "Administration",
    signIn: "Sign in", signingIn: "Signing in…",
    email: "Email", password: "Password",
    noMatch: "Those details do not match an account.",
    failed: "Could not sign you in.",
    codeTitle: "Enter your code",
    codeSub: "The six digits from your authenticator, or one of your recovery codes.",
    checking: "Checking…", continue: "Continue",
    tooLong: "That took too long. Sign in again.",
    badCode: "That code was not accepted.",
    noSignup: "A super administrator creates access to this dashboard. Contact your administrator if you need an account.",
  },
  fr: {
    admin: "Administration",
    signIn: "Se connecter", signingIn: "Connexion…",
    email: "E-mail", password: "Mot de passe",
    noMatch: "Ces informations ne correspondent à aucun compte.",
    failed: "Connexion impossible.",
    codeTitle: "Saisissez votre code",
    codeSub: "Les six chiffres de votre application d'authentification, ou l'un de vos codes de secours.",
    checking: "Vérification…", continue: "Continuer",
    tooLong: "Le délai est dépassé. Reconnectez-vous.",
    badCode: "Ce code n'a pas été accepté.",
    noSignup: "L’accès à l’administration est créé par un super administrateur. Contactez votre responsable si vous n’avez pas de compte.",
  },
  es: {
    admin: "Admin",
    signIn: "Iniciar sesión", signingIn: "Iniciando sesión…",
    email: "Correo electrónico", password: "Contraseña",
    noMatch: "Esos datos no coinciden con ninguna cuenta.",
    failed: "No se pudo iniciar sesión.",
    codeTitle: "Introduce tu código",
    codeSub: "Los seis dígitos de tu aplicación de autenticación, o uno de tus códigos de recuperación.",
    checking: "Comprobando…", continue: "Continuar",
    tooLong: "Se agotó el tiempo. Inicia sesión de nuevo.",
    badCode: "Ese código no fue aceptado.",
    noSignup: "Las cuentas del panel las crea un superadministrador. Aquí no hay registro.",
  },
  pt: {
    admin: "Admin",
    signIn: "Iniciar sessão", signingIn: "A iniciar sessão…",
    email: "E-mail", password: "Palavra-passe",
    noMatch: "Esses dados não correspondem a nenhuma conta.",
    failed: "Não foi possível iniciar sessão.",
    codeTitle: "Introduza o seu código",
    codeSub: "Os seis dígitos da sua aplicação de autenticação, ou um dos seus códigos de recuperação.",
    checking: "A verificar…", continue: "Continuar",
    tooLong: "Demorou demasiado. Inicie sessão novamente.",
    badCode: "Esse código não foi aceite.",
    noSignup: "As contas do painel são criadas por um superadministrador. Não há registo aqui.",
  },
  ar: {
    admin: "المشرف",
    signIn: "تسجيل الدخول", signingIn: "جارٍ تسجيل الدخول…",
    email: "البريد الإلكتروني", password: "كلمة المرور",
    noMatch: "هذه البيانات لا تطابق أي حساب.",
    failed: "تعذّر تسجيل دخولك.",
    codeTitle: "أدخل رمزك",
    codeSub: "الأرقام الستة من تطبيق المصادقة، أو أحد رموز الاسترداد الخاصة بك.",
    checking: "جارٍ التحقق…", continue: "متابعة",
    tooLong: "استغرق ذلك وقتًا طويلًا. سجّل الدخول مجددًا.",
    badCode: "لم يتم قبول هذا الرمز.",
    noSignup: "حسابات لوحة التحكم ينشئها مشرف عام. لا يوجد تسجيل هنا.",
  },
  zh: {
    admin: "管理员",
    signIn: "登录", signingIn: "正在登录…",
    email: "电子邮箱", password: "密码",
    noMatch: "这些信息与任何账户都不匹配。",
    failed: "无法登录。",
    codeTitle: "输入您的验证码",
    codeSub: "身份验证器中的六位数字，或您的一个恢复码。",
    checking: "正在核对…", continue: "继续",
    tooLong: "耗时过长。请重新登录。",
    badCode: "该验证码未被接受。",
    noSignup: "后台账户由超级管理员创建。此处不提供注册。",
  },
};

// components/auth/GoogleSignIn.jsx
export const googleL = {
  en: { unavailable: "Google sign-in is unavailable right now. Use your e-mail address instead." },
  fr: { unavailable: "La connexion Google est indisponible pour le moment. Utilisez plutôt votre adresse e-mail." },
  es: { unavailable: "El inicio de sesión con Google no está disponible en este momento. Usa tu correo electrónico." },
  pt: { unavailable: "O início de sessão com o Google não está disponível de momento. Utilize o seu e-mail." },
  ar: { unavailable: "تسجيل الدخول عبر Google غير متاح حاليًا. استخدم بريدك الإلكتروني بدلًا من ذلك." },
  zh: { unavailable: "Google 登录暂时不可用。请改用您的电子邮箱。" },
};

// pages/ForgotPassword.jsx
export const forgotL = {
  en: {
    title: "Forgot your password?",
    sub: "Enter the email address of your account. We'll send you a link to choose a new one.",
    email: "Email address", submit: "Send me the link", back: "← Back to sign in",
    sent: (email) => `If an account exists for ${email}, a link is on its way. It works for one hour — check your spam folder too.`,
    failed: "We couldn't send the link. Try again in a moment.",
    tooMany: "Too many requests from this connection. Try again in an hour.",
  },
  fr: {
    title: "Mot de passe oublié ?",
    sub: "Saisissez l'adresse e-mail de votre compte. Nous vous enverrons un lien pour en choisir un nouveau.",
    email: "Adresse e-mail", submit: "M'envoyer le lien", back: "← Retour à la connexion",
    sent: (email) => `Si un compte existe pour ${email}, un lien est en route. Il est valable une heure — pensez aussi aux courriers indésirables.`,
    failed: "Impossible d'envoyer le lien. Réessayez dans un instant.",
    tooMany: "Trop de demandes depuis cette connexion. Réessayez dans une heure.",
  },
  es: {
    title: "¿Olvidaste tu contraseña?",
    sub: "Introduce el correo electrónico de tu cuenta. Te enviaremos un enlace para elegir una nueva.",
    email: "Correo electrónico", submit: "Enviarme el enlace", back: "← Volver al inicio de sesión",
    sent: (email) => `Si existe una cuenta para ${email}, el enlace ya está en camino. Es válido durante una hora; revisa también tu carpeta de spam.`,
    failed: "No pudimos enviar el enlace. Inténtalo de nuevo en un momento.",
    tooMany: "Demasiadas solicitudes desde esta conexión. Inténtalo de nuevo dentro de una hora.",
  },
  pt: {
    title: "Esqueceu a palavra-passe?",
    sub: "Introduza o endereço de e-mail da sua conta. Enviaremos um link para escolher uma nova.",
    email: "Endereço de e-mail", submit: "Enviar-me o link", back: "← Voltar ao início de sessão",
    sent: (email) => `Se existir uma conta para ${email}, o link já está a caminho. É válido durante uma hora — verifique também a pasta de spam.`,
    failed: "Não foi possível enviar o link. Tente novamente dentro de instantes.",
    tooMany: "Demasiados pedidos a partir desta ligação. Tente novamente dentro de uma hora.",
  },
  ar: {
    title: "هل نسيت كلمة المرور؟",
    sub: "أدخل البريد الإلكتروني لحسابك. سنرسل لك رابطًا لاختيار كلمة مرور جديدة.",
    email: "البريد الإلكتروني", submit: "أرسل لي الرابط", back: "← العودة إلى تسجيل الدخول",
    sent: (email) => `إذا كان هناك حساب مرتبط بـ ${email}، فالرابط في طريقه إليك. يصلح لمدة ساعة واحدة — تحقق أيضًا من مجلد الرسائل غير المرغوب فيها.`,
    failed: "تعذّر إرسال الرابط. حاول مجددًا بعد قليل.",
    tooMany: "طلبات كثيرة جدًا من هذا الاتصال. حاول مجددًا بعد ساعة.",
  },
  zh: {
    title: "忘记密码？",
    sub: "请输入您账户的电子邮箱。我们会向您发送一个用于设置新密码的链接。",
    email: "电子邮箱", submit: "发送链接给我", back: "← 返回登录",
    sent: (email) => `如果 ${email} 对应的账户存在，链接已在发送中。链接一小时内有效——也请查看垃圾邮件文件夹。`,
    failed: "无法发送链接。请稍后再试。",
    tooMany: "此网络连接的请求过多。请一小时后再试。",
  },
};

// pages/ResetPassword.jsx
export const resetL = {
  en: {
    title: "Choose a new password", sub: "Then sign in with it. Every other session will be signed out.",
    password: "New password", confirm: "Confirm the new password", rule: "At least 10 characters.",
    mismatch: "The two passwords differ.", submit: "Save the new password",
    done: "Password changed — sign in with it.", failed: "This link is not valid.",
    noToken: "This link is incomplete.", askAgain: "Ask for a new link",
  },
  fr: {
    title: "Choisissez un nouveau mot de passe", sub: "Choisissez un mot de passe, puis utilisez-le pour vous reconnecter. Les autres sessions seront déconnectées.",
    password: "Nouveau mot de passe", confirm: "Confirmez le nouveau mot de passe", rule: "Au moins 10 caractères.",
    mismatch: "Les deux mots de passe diffèrent.", submit: "Enregistrer le nouveau mot de passe",
    done: "Mot de passe modifié. Vous pouvez vous reconnecter.", failed: "Ce lien n'est pas valide.",
    noToken: "Ce lien est incomplet.", askAgain: "Demander un nouveau lien",
  },
  es: {
    title: "Elige una nueva contraseña", sub: "Luego inicia sesión con ella. Todas las demás sesiones se cerrarán.",
    password: "Nueva contraseña", confirm: "Confirma la nueva contraseña", rule: "Al menos 10 caracteres.",
    mismatch: "Las dos contraseñas no coinciden.", submit: "Guardar la nueva contraseña",
    done: "Contraseña cambiada; inicia sesión con ella.", failed: "Este enlace no es válido.",
    noToken: "Este enlace está incompleto.", askAgain: "Solicitar un nuevo enlace",
  },
  pt: {
    title: "Escolha uma nova palavra-passe", sub: "Depois inicie sessão com ela. Todas as outras sessões serão terminadas.",
    password: "Nova palavra-passe", confirm: "Confirme a nova palavra-passe", rule: "Pelo menos 10 caracteres.",
    mismatch: "As duas palavras-passe são diferentes.", submit: "Guardar a nova palavra-passe",
    done: "Palavra-passe alterada — inicie sessão com ela.", failed: "Este link não é válido.",
    noToken: "Este link está incompleto.", askAgain: "Pedir um novo link",
  },
  ar: {
    title: "اختر كلمة مرور جديدة", sub: "ثم سجّل الدخول بها. سيتم تسجيل الخروج من جميع الجلسات الأخرى.",
    password: "كلمة المرور الجديدة", confirm: "تأكيد كلمة المرور الجديدة", rule: "10 أحرف على الأقل.",
    mismatch: "كلمتا المرور غير متطابقتين.", submit: "حفظ كلمة المرور الجديدة",
    done: "تم تغيير كلمة المرور — سجّل الدخول بها.", failed: "هذا الرابط غير صالح.",
    noToken: "هذا الرابط غير مكتمل.", askAgain: "طلب رابط جديد",
  },
  zh: {
    title: "设置新密码", sub: "然后使用新密码登录。其他所有会话都将被退出。",
    password: "新密码", confirm: "确认新密码", rule: "至少 10 个字符。",
    mismatch: "两次输入的密码不一致。", submit: "保存新密码",
    done: "密码已更改——请使用新密码登录。", failed: "此链接无效。",
    noToken: "此链接不完整。", askAgain: "申请新链接",
  },
};

// pages/Account.jsx
export const accountL = {
  en: {
    title: "My account", sub: "Your details, your bookings and your password.",
    profile: "Profile", name: "Name", email: "Email address", bookings: "See my bookings →", support: "Contact support",
    password: "Password", passwordSub: "Changing it signs every other session out.",
    current: "Current password", next: "New password", confirm: "Confirm the new password",
    rule: "At least 10 characters, different from the current one.", mismatch: "The two passwords differ.",
    submit: "Change password", changed: "Password changed.", failed: "The password could not be changed.",
    data: "Your data", dataSub: "You can ask for a copy of the data we hold about you, or for its deletion.", dataCta: "Write to support →",
    deleteTitle: "Delete my account", deleteSub: "Deleting your account removes your sign-in profile. It does not cancel bookings or erase records that must be retained. Partner and staff accounts require a closure review.", deleteOpen: "Delete my account", deletePassword: "Your password, to confirm", deleteConfirm: "Delete permanently", deleteCancel: "Cancel", deleteWarn: "This cannot be undone.", deleted: "Your account has been deleted.", deleteRequested: "Your request has been recorded. This account has partner or staff access, so its closure requires review. Contact Support if you need an update.", wrongPassword: "Wrong password.", tooMany: "Too many attempts — try again in a few minutes.", deleteFailed: "The account could not be deleted. Try again or contact support.",
  },
  fr: {
    title: "Mon compte", sub: "Vos informations, vos réservations et votre mot de passe.",
    profile: "Profil", name: "Nom", email: "Adresse e-mail", bookings: "Voir mes réservations →", support: "Contacter l'assistance",
    password: "Mot de passe", passwordSub: "Après la modification, les autres sessions seront déconnectées.",
    current: "Mot de passe actuel", next: "Nouveau mot de passe", confirm: "Confirmez le nouveau mot de passe",
    rule: "Au moins 10 caractères et différent du mot de passe actuel.", mismatch: "Les deux mots de passe diffèrent.",
    submit: "Changer le mot de passe", changed: "Mot de passe modifié.", failed: "Le mot de passe n'a pas pu être modifié.",
    data: "Vos données", dataSub: "Vous pouvez demander une copie des données que nous détenons sur vous, ou leur suppression.", dataCta: "Écrire à l'assistance →",
    deleteTitle: "Supprimer mon compte", deleteSub: "La suppression retire votre profil de connexion. Elle n’annule pas vos réservations et n’efface pas les documents à conserver. Les comptes partenaires et équipe nécessitent un examen avant fermeture.", deleteOpen: "Supprimer mon compte", deletePassword: "Votre mot de passe, pour confirmer", deleteConfirm: "Supprimer définitivement", deleteCancel: "Annuler", deleteWarn: "Cette action est irréversible.", deleted: "Votre compte a été supprimé.", deleteRequested: "Votre demande est enregistrée. Ce compte dispose d’un accès partenaire ou équipe : sa fermeture nécessite un examen. Contactez l’assistance pour faire le point sur votre demande.", wrongPassword: "Mot de passe incorrect.", tooMany: "Trop de tentatives — réessayez dans quelques minutes.", deleteFailed: "Le compte n'a pas pu être supprimé. Réessayez ou contactez l'assistance.",
  },
  es: {
    title: "Mi cuenta", sub: "Tus datos, tus reservas y tu contraseña.",
    profile: "Perfil", name: "Nombre", email: "Correo electrónico", bookings: "Ver mis reservas →", support: "Contactar con soporte",
    password: "Contraseña", passwordSub: "Cambiarla cierra todas las demás sesiones.",
    current: "Contraseña actual", next: "Nueva contraseña", confirm: "Confirma la nueva contraseña",
    rule: "Al menos 10 caracteres, distinta de la actual.", mismatch: "Las dos contraseñas no coinciden.",
    submit: "Cambiar contraseña", changed: "Contraseña cambiada.", failed: "No se pudo cambiar la contraseña.",
    data: "Tus datos", dataSub: "Puedes solicitar una copia de los datos que tenemos sobre ti, o su eliminación.", dataCta: "Escribir a soporte →",
    deleteTitle: "Eliminar mi cuenta", deleteSub: "La eliminación retira su perfil de acceso. No cancela reservas ni borra registros que deban conservarse. Las cuentas de socios y equipo requieren revisión.", deleteOpen: "Eliminar mi cuenta", deletePassword: "Tu contraseña, para confirmar", deleteConfirm: "Eliminar definitivamente", deleteCancel: "Cancelar", deleteWarn: "Esta acción no se puede deshacer.", deleted: "Tu cuenta ha sido eliminada.", deleteRequested: "Su solicitud está registrada. Como la cuenta tiene acceso de socio o de equipo, el cierre requiere una revisión. Contacte con Asistencia para consultar el estado.", wrongPassword: "Contraseña incorrecta.", tooMany: "Demasiados intentos: inténtalo de nuevo en unos minutos.", deleteFailed: "No se pudo eliminar la cuenta. Inténtalo de nuevo o contacta con soporte.",
  },
  pt: {
    title: "A minha conta", sub: "Os seus dados, as suas reservas e a sua palavra-passe.",
    profile: "Perfil", name: "Nome", email: "Endereço de e-mail", bookings: "Ver as minhas reservas →", support: "Contactar o apoio",
    password: "Palavra-passe", passwordSub: "Alterá-la termina todas as outras sessões.",
    current: "Palavra-passe atual", next: "Nova palavra-passe", confirm: "Confirme a nova palavra-passe",
    rule: "Pelo menos 10 caracteres, diferente da atual.", mismatch: "As duas palavras-passe são diferentes.",
    submit: "Alterar palavra-passe", changed: "Palavra-passe alterada.", failed: "Não foi possível alterar a palavra-passe.",
    data: "Os seus dados", dataSub: "Pode pedir uma cópia dos dados que temos sobre si, ou a sua eliminação.", dataCta: "Escrever ao apoio →",
    deleteTitle: "Eliminar a minha conta", deleteSub: "A eliminação remove o perfil de acesso. Não cancela reservas nem apaga registos que devam ser conservados. As contas de parceiros e equipa requerem análise.", deleteOpen: "Eliminar a minha conta", deletePassword: "A sua palavra-passe, para confirmar", deleteConfirm: "Eliminar definitivamente", deleteCancel: "Cancelar", deleteWarn: "Esta ação não pode ser anulada.", deleted: "A sua conta foi eliminada.", deleteRequested: "O pedido foi registado. Como a conta tem acesso de parceiro ou equipa, o encerramento requer análise. Contacte a Assistência para acompanhar o pedido.", wrongPassword: "Palavra-passe incorreta.", tooMany: "Demasiadas tentativas — tente novamente dentro de alguns minutos.", deleteFailed: "Não foi possível eliminar a conta. Tente novamente ou contacte o apoio.",
  },
  ar: {
    title: "حسابي", sub: "بياناتك وحجوزاتك وكلمة مرورك.",
    profile: "الملف الشخصي", name: "الاسم", email: "البريد الإلكتروني", bookings: "عرض حجوزاتي →", support: "التواصل مع الدعم",
    password: "كلمة المرور", passwordSub: "تغييرها يسجّل الخروج من جميع الجلسات الأخرى.",
    current: "كلمة المرور الحالية", next: "كلمة المرور الجديدة", confirm: "تأكيد كلمة المرور الجديدة",
    rule: "10 أحرف على الأقل، ومختلفة عن الحالية.", mismatch: "كلمتا المرور غير متطابقتين.",
    submit: "تغيير كلمة المرور", changed: "تم تغيير كلمة المرور.", failed: "تعذّر تغيير كلمة المرور.",
    data: "بياناتك", dataSub: "يمكنك طلب نسخة من البيانات التي نحتفظ بها عنك، أو طلب حذفها.", dataCta: "مراسلة الدعم →",
    deleteTitle: "حذف حسابي", deleteSub: "يؤدي الحذف إلى إزالة ملف تسجيل الدخول، دون إلغاء الحجوزات أو حذف السجلات الواجب الاحتفاظ بها. تتطلب حسابات الشركاء والفريق مراجعة.", deleteOpen: "حذف حسابي", deletePassword: "كلمة المرور للتأكيد", deleteConfirm: "حذف نهائي", deleteCancel: "إلغاء", deleteWarn: "لا يمكن التراجع عن هذا الإجراء.", deleted: "تم حذف حسابك.", deleteRequested: "تم تسجيل طلبك. يتطلب إغلاق الحساب مراجعة لارتباطه بوصول شريك أو فريق. تواصل مع الدعم لمتابعة الطلب.", wrongPassword: "كلمة المرور غير صحيحة.", tooMany: "محاولات كثيرة — أعد المحاولة بعد بضع دقائق.", deleteFailed: "تعذر حذف الحساب. أعد المحاولة أو تواصل مع الدعم.",
  },
  zh: {
    title: "我的账户", sub: "您的信息、预订和密码。",
    profile: "个人资料", name: "姓名", email: "电子邮箱", bookings: "查看我的预订 →", support: "联系客服",
    password: "密码", passwordSub: "更改密码会退出其他所有会话。",
    current: "当前密码", next: "新密码", confirm: "确认新密码",
    rule: "至少 10 个字符，且与当前密码不同。", mismatch: "两次输入的密码不一致。",
    submit: "更改密码", changed: "密码已更改。", failed: "无法更改密码。",
    data: "您的数据", dataSub: "您可以申请获取我们所持有的关于您的数据副本，或申请删除这些数据。", dataCta: "写信给客服 →",
    deleteTitle: "删除我的账户", deleteSub: "删除账户会移除登录资料，但不会取消预订或删除必须保留的记录。合作伙伴和团队账户需先审核。", deleteOpen: "删除我的账户", deletePassword: "请输入密码以确认", deleteConfirm: "永久删除", deleteCancel: "取消", deleteWarn: "此操作无法撤销。", deleted: "您的账户已删除。", deleteRequested: "申请已记录。此账户关联合作伙伴或团队权限，关闭前需要审核。您可联系客服跟进申请。", wrongPassword: "密码错误。", tooMany: "尝试次数过多，请几分钟后再试。", deleteFailed: "无法删除账户。请重试或联系客服。",
  },
};
